import request from '@/utils/request'

// 获取在线看房列表
export function postVisitHouse (object) {
  return request({
    url: '/platform-business/renting-ad/page',
    method: 'post',
    params: object
  })
}
// 在线看房详情
export function postVisitHouseDetail (object) {
  return request({
    url: '/platform-business/renting-ad/detail',
    method: 'post',
    data: object
  })
}
// 标签列表
export function postVisitHouseLabel (object) {
  return request({
    url: '/platform-business/label/list',
    method: 'get',
    data: object
  })
}

// 获取项目列表
export function getProjectListApi (object) {
  return request({
    url: '/cent-data-core/org/project-chose/v2',
    method: 'post',
    data: object
  })
}

// 登录接口
export function loginApi (data) {
  return request({
    url: '/cent-auth/login',
    method: 'post',
    data
  })
}

//查询人脸数据
export function faceQuery (data) {
  return request({
    url: '/cent-face/face/query',
    method: 'get',
    params: data
  })
}

//添加用户人脸
export function addUserFace (data) { 
  return request({
    url: '/cent-face/face/single/user/add',
    method: 'post',
    data
  })
}

//同步业主人脸
export function updateUserFace (data) { 
  return request({
    url: '/platform-residence/residentInfo/updateUserFace',
    method: 'post',
    params: data
  })
}

// 根据经纬度查询项目  
export function getProjectByLatitudeAndLongitude (data) { 
  return request({
    url: '/cent-data-core/project/closest',
    method: 'post',
    data
  })
}

// 验证手机号是否存在
export function phoneExistCheckApi(data) {
  return request({
    url: '/cent-data-core/account/phone-exist-check',
    method: 'get',
    params: data
  })
}

// 获取验证码(不需要校验token)
export function sendMsgCodeOpenApi (data) {
  return request({
    url: '/cent-data-core/account/send-msg-code-open',
    method: 'get',
    params: data
  })
}

// 获取验证码(需要校验token)
export function sendMsgCodeApi(data) {
  return request({
    url: '/cent-data-core/personal/send-msg-code',
    method: 'get',
    params: data
  })
}
// 校验验证码
export function msgCodeVerifyApi(data) {
  return request({
    url: '/cent-data-core/account/msg-code-verify',
    method: 'post',
    data
  })
}

// 密码设置校验 不能与用户名值相同
export function pwdResetVerifyApi(data) {
  return request({
    url: '/cent-data-core/account/pwd-reset-verify',
    method: 'post',
    data
  })
}

// 首次登陆设置密码
export function modifyPwdApi (data) {
  return request({
    url: '/cent-data-core/account/modify-pwd',
    method: 'post',
    data
  })
}
// 忘记密码-设置新密码
export function pwdForgotResetApi(data) {
  return request({
    url: '/cent-data-core/account/pwd-forgot-reset',
    method: 'post',
    data
  })
}
// 退出登录
export function logoutApi(data) {
  return request({
    url: '/cent-auth/logout',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js